export default "__VITE_ASSET__Ct2vrF4e__"